import { render, staticRenderFns } from "./PoolNumber.vue?vue&type=template&id=1b3363e3&"
import script from "./PoolNumber.vue?vue&type=script&lang=ts&"
export * from "./PoolNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports